// extracted by mini-css-extract-plugin
export default {"modalCTAWrapper":"EditDuUserApproval_modalCTAWrapper__naX6j"};